import { Chakra } from "@airhelp/react-ui-components";
import { CheckmarkIcon } from "styles/icons";
import Grid from "modules/common/components/Grid";
import bgStyles from "./CTA.styles";
import type { CTAProps } from "./CTA.d";

const { Flex, Button, Heading, List, ListItem, ListIcon, HStack, Box } = Chakra;

const CTA = ({ text, checkboxes = [], background = "primary", actionButtonText, actionButtonHref }: CTAProps) => (
  <Grid mb={0}>
    <Box gridColumn={{ base: "span 1", md: "span 12" }}>
      <Flex
        bg={bgStyles[background].color}
        p={6}
        color="white"
        align={{ base: "stretch", md: "flex-start", lg: "center" }}
        justify="space-between"
        borderRadius="lg"
        bgImage={bgStyles[background].bgImage}
        bgRepeat="no-repeat"
        bgSize="contain"
        bgPos="right"
        flexDir={{ base: "column", lg: "row" }}
      >
        <Flex flexWrap="wrap" justify="space-between" flexGrow={1}>
          <Heading color="inherit" variant="h3" as="h3" fontWeight="bold" alignSelf="center" lineHeight="revert">
            {text}
          </Heading>
          {!!checkboxes && (
            <List d={{ base: "none", xl: "flex" }} py={2}>
              <HStack spacing={4}>
                {checkboxes.map((item) => (
                  <ListItem key={item} flexShrink={0}>
                    <ListIcon as={CheckmarkIcon} />
                    {item}
                  </ListItem>
                ))}
              </HStack>
            </List>
          )}
        </Flex>
        <Button
          as="a"
          variant="subtle"
          flexShrink={0}
          mt={{ base: 6, lg: 0 }}
          href={actionButtonHref}
          ml={{ base: 0, lg: 5 }}
          alignSelf={{ base: "streach", lg: "flex-start" }}
        >
          {actionButtonText}
        </Button>
      </Flex>
    </Box>
  </Grid>
);

export default CTA;
